export interface DimensionValue {
  length: string;
  width: string;
  height: string;
}

export function emptyDimensions(): DimensionValue {
  return { length: "", width: "", height: "" };
}

export function dimensionsFromRecord(length: string | null, width: string | null, height: string | null): DimensionValue {
  return { length: length || "", width: width || "", height: height || "" };
}

export function DimensionCubeFields({ value, onChange }: {
  value: DimensionValue;
  onChange: (next: DimensionValue) => void;
}) {
  const parsed = [value.length, value.width, value.height].map((part) => Math.max(Number(part) || 1, 1));
  const max = Math.max(...parsed);
  const length = 58 + (parsed[0] / max) * 52;
  const width = 24 + (parsed[1] / max) * 34;
  const height = 46 + (parsed[2] / max) * 52;
  const baseY = 138;
  const topY = baseY - height;
  const leftX = 25;
  const rightX = leftX + length;

  return (
    <section className="dimension-editor" aria-labelledby="dimension-heading">
      <div className="dimension-copy">
        <strong id="dimension-heading">Custom dimensions</strong>
        <span>Enter exterior measurements in inches.</span>
        <div className="dimension-inputs">
          {(["length", "width", "height"] as const).map((field) => (
            <label key={field}>
              <span>{field[0].toUpperCase() + field.slice(1)}</span>
              <div><input type="number" min="0" step="0.25" inputMode="decimal" value={value[field]} onChange={(event) => onChange({ ...value, [field]: event.target.value })} placeholder="0" /><small>in</small></div>
            </label>
          ))}
        </div>
      </div>
      <svg className="dimension-cube" viewBox="0 0 190 165" role="img" aria-label={`Size preview: ${value.length || 0} by ${value.width || 0} by ${value.height || 0} inches`}>
        <polygon points={`${leftX},${topY} ${rightX},${topY} ${rightX + width},${topY - width / 2} ${leftX + width},${topY - width / 2}`} className="cube-top" />
        <polygon points={`${rightX},${topY} ${rightX + width},${topY - width / 2} ${rightX + width},${baseY - width / 2} ${rightX},${baseY}`} className="cube-side" />
        <polygon points={`${leftX},${topY} ${rightX},${topY} ${rightX},${baseY} ${leftX},${baseY}`} className="cube-front" />
        <text x={(leftX + rightX) / 2} y={baseY + 18} textAnchor="middle">L {value.length || "—"} in</text>
        <text x={rightX + width + 5} y={(topY + baseY) / 2} textAnchor="start">H</text>
        <text x={rightX + width / 2} y={topY - width / 2 - 8} textAnchor="middle">W {value.width || "—"}</text>
      </svg>
    </section>
  );
}
